import React from 'react';
import PropTypes from 'prop-types';
import { LuChartColumn, LuEye, LuEyeOff, LuLockKeyhole } from 'react-icons/lu';
import PageHero from '../../../components/data/PageHero';
import Button from '../../../components/ui/Button';
import useAccessText from '../accessText';

/** Title card of Sayfa Yetkileri: show / hide inactive employees and the usage statistics. */
const PageAccessHeader = ({ showPassive, passiveCount, onTogglePassive, onStats }) => {
  const { label } = useAccessText();
  const PassiveIcon = showPassive ? LuEyeOff : LuEye;
  return (
    <PageHero
      icon={LuLockKeyhole}
      gradient="tw-from-indigo-400 tw-to-violet-600 tw-shadow-indigo-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      actionsClassName="tw-grid tw-grid-cols-2 tw-gap-2 sm:tw-flex sm:tw-flex-wrap sm:tw-items-center lg:tw-justify-end"
    >
      <Button
        onClick={onTogglePassive}
        aria-pressed={showPassive}
        title={showPassive ? label('actions.hidePassiveHint') : label('actions.showPassiveHint')}
        className={showPassive ? 'tw-ring-2 tw-ring-slate-400/40' : ''}
      >
        <PassiveIcon aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-slate-500 dark:tw-text-slate-400" />
        {showPassive ? label('actions.hidePassive') : label('actions.showPassive')}
        {passiveCount > 0 && (
          <span className="tw-rounded-full tw-bg-slate-900/[0.07] tw-px-1.5 tw-py-px tw-text-[11px] tw-font-bold tw-tabular-nums dark:tw-bg-white/10">{passiveCount}</span>
        )}
      </Button>
      <Button onClick={onStats} title={label('actions.statsHint')}>
        <LuChartColumn aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-sky-600 dark:tw-text-sky-300" />
        {label('actions.stats')}
      </Button>
    </PageHero>
  );
};

PageAccessHeader.propTypes = {
  showPassive: PropTypes.bool.isRequired,
  passiveCount: PropTypes.number.isRequired,
  onTogglePassive: PropTypes.func.isRequired,
  onStats: PropTypes.func.isRequired,
};

export default PageAccessHeader;
